import { AfterViewInit, Component, ContentChild, ElementRef, EventEmitter, Inject, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';

import "core-js";

import { MatDialog } from '@angular/material/dialog';
import { APP_BASE_HREF } from '@angular/common';
import { BehaviorSubject, combineLatest, interval, Observable, of, ReplaySubject, merge, Subject, EMPTY, empty, NEVER, fromEvent } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, map, startWith, switchMap, tap, share } from 'rxjs/operators';
import { MatPaginator } from '@angular/material/paginator';
import { v4 as uuidv4 } from 'uuid';

import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ObservableInput } from 'ngx-observable-input';

import { NgxMultiExcludes } from '../../../operators/ngx/multi-excludes/ngx-multi-excludes.operator';
import { MatPageArray } from '../../../operators/mat/page-array/mat-page-array.operator';
import { Multi } from '../../../interfaces/multi.interface';
import { Color } from '@swimlane/ngx-charts';


@Component({
  selector: 'stacked-bar-chart',
  templateUrl: './stacked-bar-chart.component.html',
  styleUrls: ['./stacked-bar-chart.component.css'],
  providers: [
    { provide: MatPaginatorIntl }
  ]
})
export class StackedBarChartComponent implements OnInit, AfterViewInit {


  @ObservableInput()
  @Input("results")
  results$: Observable<Multi[]>;
  _results: Observable<Multi[]>;
  _resultsPage: Observable<Multi[]>;

  @Input()
  options: StackedBarChartOptions = null;


  @Output()
  select: EventEmitter<any> = new EventEmitter();

  @ContentChild('eveTooltipTemplate') eveTooltipTemplate: TemplateRef<any>;
  @ViewChild(MatPaginator, { static: false }) set paginator(paginator: MatPaginator) { this.paginatorObserable.next(paginator); };
  paginatorObserable: BehaviorSubject<MatPaginator> = new BehaviorSubject(null);


  chartContainerElement: any = null;


  scheme = {
    domain: ['#00abca', '#be0078', '#85bf75', '#c23133', '#00B862', '#AFDF0A', '#3F51B5', '#FF9800']
  };
  gradient: boolean = true;
  legend: boolean = true;
  legendPosition: string = 'right';
  legendTitle: string = "";
  labels: boolean = true;
  doughnut: boolean = true;
  showXAxis = true;
  showYAxis = true;
  showLegend = true;
  showXAxisLabel = true;
  showYAxisLabel = true;
  animations = true

  excludeResults: BehaviorSubject<String[]> = new BehaviorSubject([]);






  parentWidth: Observable<number> = interval(10).pipe(
    map(() => this.chartContainerElement.clientWidth),
    distinctUntilChanged()
  );

  parentHeight: Observable<number> = interval(10).pipe(
    map(() => {
      return this.chartContainerElement.clientHeight;
    }),
    distinctUntilChanged()
  );

  view: Observable<number[]> = combineLatest(this.parentWidth, this.parentHeight).pipe(
    map(a => [a[0], a[1] -  20 ]),
    debounceTime(50)
  );



  legendStyles: Observable<SafeHtml> = this.excludeResults.pipe(
    map(excludeResult => {
      return this.sanitizer.bypassSecurityTrustHtml(excludeResult.map((e, p) => `<style>
      .${this.componenetId} ngx-charts-legend-entry [title="${e}"] {
        opacity: 0.2;
      }
    </style>`
      ).join("\r\n"))
    })
  );

  componenetId: String = "componenetId_" + uuidv4().replaceAll("-", "");

  constructor(
    private elRef: ElementRef,
    private sanitizer: DomSanitizer,
    private matPaginatorIntl: MatPaginatorIntl
  ) {
    
  }
    


  ngOnInit() {
    

    this._results = this.results$.pipe(
      NgxMultiExcludes(this.excludeResults)
    );
    this._resultsPage = this._results.pipe(
      MatPageArray(this.paginatorObserable)
    );
      /*
      combineLatest(this.results$, this.excludeResults).pipe(
      map(([results, excludeResults]) => {

        const newResults = results.map(r => Object.assign({}, r, { series: r.series.map(s => excludeResults.indexOf(s.name) == -1 ? s : Object.assign({}, s, { value: 0 })) }));

        return newResults
      }),
    )*/


  }

  ngAfterViewInit(): void {
    this.elRef.nativeElement.classList.add(this.componenetId);
    this.chartContainerElement = this.elRef.nativeElement.querySelectorAll(".chart-container")[0];
  }





  onSelect(data): void {
    if (!this.isLegend(data)) {
      this.select.emit(data);
    }
    else {
      const excludeResults = this.excludeResults.getValue();



      if (excludeResults.indexOf(data) == -1) this.excludeResults.next(excludeResults.concat([data]));
      else this.excludeResults.next(excludeResults.filter(i => i != data));
    }
  }
  isLegend = (event) => typeof event === 'string';





}

@Injectable()
export class MatPaginatorIntlLabels extends MatPaginatorIntl {
  override itemsPerPageLabel = 'Users per page:';
}


export interface StackedBarChartOptions {
  width: number,
  height: number,
  chartHeader: string,
  xAxisLabel: string,
  yAxisLabel: string,
  colourScheme: string | Color
}
